/**
 * The optional email areas the Email preferences card exposes, in render
 * order. The ids are the wire contract with the service (each one is an entry
 * in the users-table `emailpreferences` denylist — see the service's
 * EmailPreferenceAreas); the labels and hints are UI copy owned here.
 *
 * The card renders this list, never the server's `areas` echo — that echo
 * exists only so a renamed or retired id on the service side can be noticed.
 * Transactional mail (receipts, security, PIN reset) has no area id and is
 * always sent, so it never appears here.
 */
export type EmailAreaId = "promotions" | "product-news" | "tips-tutorials";

export type EmailArea = {
  id: EmailAreaId;
  label: string;
  hint: string;
};

export const EMAIL_AREAS: EmailArea[] = [
  {
    id: "promotions",
    label: "Promotions",
    hint: "Offers, discounts and referral campaigns.",
  },
  {
    id: "product-news",
    label: "Product news",
    hint: "New features and app updates.",
  },
  {
    id: "tips-tutorials",
    label: "Tips & tutorials",
    hint: "How-to guides and bookkeeping tips.",
  },
];
